"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTd = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importDefault(require("react"));
var Option = antd_1.Select.Option;
var SelectTd = function (props) {
    var _a;
    var _b = props.cell, colSpan = _b.colSpan, options = _b.options, path = _b.path, rowSpan = _b.rowSpan, value = _b.value;
    var style = props.style;
    var onChangeV = props.onValueUpdate;
    var isValueUndefined = (value + "").trim() === "" || value === null || value === undefined;
    var displayError = props.required && isValueUndefined && props.triedSubmitting;
    return ((0, jsx_runtime_1.jsx)("td", __assign({ style: style, className: index_modules_css_1.default.gridTd, colSpan: colSpan, rowSpan: rowSpan }, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: displayError ? "error" : undefined }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ className: "hidden-on-print", style: {
                    width: "100%",
                    height: "100%",
                    borderColor: displayError ? "#FF0000" : "none",
                }, onChange: function (value) { return (onChangeV || lodash_1.noop)(path, value); }, defaultValue: value, showSearch: true, optionFilterProp: "children", mode: (_a = props.mode) !== null && _a !== void 0 ? _a : null }, { children: (0, lodash_1.map)(options, function (option, idx) { return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: option.value }, { children: option.text }), idx)); }) })) })) })));
};
exports.SelectTd = SelectTd;
